import {Pipe, PipeTransform} from '@angular/core';
import {stringToColor} from '@vendure/admin-ui/core';

@Pipe({
  name: 'stringToColor',
  pure: true,
})
export class StringToColorPipe implements PipeTransform {
  transform(value: string): string {
    return stringToColor(value);
  }
}
